import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import { ButtonText } from '@prisjakt/ui/button/variants';

export const FilterWrapper = styled.div`
  display: flex;
  position: relative;
  margin-right: ${layout.measurements.spacing050};
`;

export const FilterButtonText = styled(ButtonText)`
  white-space: nowrap;
`;

export const FilterPopup = styled.div`
  background: ${p => p.theme.bg.primary};
  margin-top: ${layout.measurements.spacing050};
  width: 360px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  border: 1px solid ${p => p.theme.lines.primary};
`;

export const FilterContent = styled.div`
  max-height: 400px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overscroll-behavior: contain;
`;

export const Content = styled.div`
  margin-bottom: ${layout.measurements.spacing050};
`;
